const dateTimeStr = new Date()?.toISOString();
const str = '';
const decimal = 0.00;

export const elevatorModelGet = ({ id = '', userId = '', isEven = true }) => {
    return {
        id: id,
        userId: userId,
        brand: str,
        both: false,
        created: dateTimeStr,
        description: str,
        even: isEven,
        height: decimal,
        manufactured: dateTimeStr,
        maxWeight: decimal,
        model: str,
        long: decimal,
        odd: false,
        serial: str,
        width: decimal,
    }
};